export const colorArray = [
  "bg-green-200",
  "bg-fuchsia-200",
  "bg-blue-200",
  "bg-teal-200",
  "bg-amber-200",
  "bg-lime-200",
  "bg-cyan-200",
  "bg-rose-200",
  "bg-purple-200",
];
